import { style, styleVariants } from "@vanilla-extract/css";
import { semanticThemeTokens } from "../theme/ThemeTokens.css";

// Full-screen click-catcher behind the drawer; clicking it dismisses.
export const overlay = style({
  position: "fixed",
  inset: 0,
  zIndex: 1000,
  border: "none",
  padding: 0,
  margin: 0,
  cursor: "default",
  backgroundColor: "hsla(0, 0%, 0%, 0.2)"
});

// Edge-anchored panel that slides in from off-screen. Width is supplied by the
// caller (the `width` prop) so one drawer can host different content widths.
export const drawer = style({
  position: "fixed",
  top: 0,
  zIndex: 1001,
  height: "100vh",
  maxWidth: "100vw",
  display: "flex",
  flexDirection: "column",
  backgroundColor: semanticThemeTokens.drawer.backgroundColor,
  color: semanticThemeTokens.color.textColor,
  transition: "transform 200ms ease"
});

// Which edge the panel is anchored to. Each side sets its own resting offset,
// the direction it slides out to, and a shadow cast back over the page.
export const drawerSide = styleVariants({
  right: {
    right: 0,
    boxShadow: "-4px 0 16px hsla(0, 0%, 0%, 0.25)",
    transform: "translateX(100%)"
  },
  left: {
    left: 0,
    boxShadow: "4px 0 16px hsla(0, 0%, 0%, 0.25)",
    transform: "translateX(-100%)"
  }
});

// Declared after `drawerSide` so it wins the transform: both sides rest at 0
// when open, and vanilla-extract emits rules in source order.
export const drawerOpen = style({
  transform: "translateX(0)"
});
